/* MED-COVER — Hover-Bildwechsel (Crossfade) auf Startseiten-Produktkarten */
(function () {
  function buildCard(card) {
    if (card.dataset.mcHover) return;
    var imgs = card.querySelectorAll('.product-media__image');
    if (imgs.length < 2) return; // nur mit 2+ Bildern
    var slide0 = card.querySelector('slideshow-slide');
    if (!slide0) return;
    var second = imgs[1];
    var overlay = document.createElement('img');
    overlay.src = second.currentSrc || second.src;
    if (second.getAttribute('srcset')) overlay.srcset = second.getAttribute('srcset');
    if (second.getAttribute('sizes')) overlay.sizes = second.getAttribute('sizes');
    overlay.alt = '';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.loading = 'lazy';
    overlay.className = 'mc-hover-image';
    var s = overlay.style;
    s.position = 'absolute';
    s.top = '0';
    s.left = '0';
    s.width = '100%';
    s.height = '100%';
    s.objectFit = getComputedStyle(imgs[0]).objectFit || 'cover';
    s.backgroundColor = '#FAFAF8';
    s.opacity = '0';
    s.transition = 'opacity .35s ease';
    s.pointerEvents = 'none';
    s.zIndex = '1';
    slide0.appendChild(overlay);
    card.dataset.mcHover = '1';
    card.addEventListener('mouseenter', function () { overlay.style.opacity = '1'; });
    card.addEventListener('mouseleave', function () { overlay.style.opacity = '0'; });
  }
  function init() {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    main.querySelectorAll('.product-card').forEach(buildCard);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();

/* ===== HCP-OPTIN START — Eintritts-Hinweis fuer medizinische Fachkraefte (temporaer; zum Entfernen einfach diesen Block loeschen) ===== */
(function () {
  var KEY = 'mc_hcp_ack_v1';
  try { if (localStorage.getItem(KEY) === '1') return; } catch (e) {}
  function show() {
    if (document.getElementById('mc-hcp-overlay')) return;
    var css = '#mc-hcp-overlay{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(13,31,43,.78);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);}'
      + '#mc-hcp-card{background:#fff;max-width:460px;width:100%;box-sizing:border-box;border-radius:16px;padding:32px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);}'
      + '#mc-hcp-card h2{margin:0 0 12px;font-size:1.25rem;line-height:1.3;color:#23423A;}'
      + '#mc-hcp-card p{margin:0 0 22px;font-size:.98rem;line-height:1.6;color:#3a3a3a;}'
      + '#mc-hcp-card .mc-hcp-btn{display:block;width:100%;box-sizing:border-box;text-align:center;border:none;border-radius:10px;cursor:pointer;font-family:inherit;}'
      + '#mc-hcp-yes{background:#23423A;color:#fff;padding:14px 18px;font-size:1rem;font-weight:600;}'
      + '#mc-hcp-no{background:transparent;color:#6b6b6b;text-decoration:underline;margin-top:10px;font-weight:500;font-size:.9rem;padding:8px;}';
    var st = document.createElement('style'); st.id = 'mc-hcp-style'; st.textContent = css; (document.head || document.documentElement).appendChild(st);
    var ov = document.createElement('div');
    ov.id = 'mc-hcp-overlay';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-labelledby', 'mc-hcp-title');
    ov.innerHTML = '<div id="mc-hcp-card">'
      + '<h2 id="mc-hcp-title">Hinweis für medizinische Fachkräfte</h2>'
      + '<p>Die Produkte und Informationen auf med-cover.de richten sich an medizinische und pflegerische Fachkräfte (Medical &amp; Healthcare Professionals). Bitte bestätigen Sie, dass Sie dieser Gruppe angehören.</p>'
      + '<button type="button" id="mc-hcp-yes" class="mc-hcp-btn">Ja, ich bin Fachkraft</button>'
      + '<button type="button" id="mc-hcp-no" class="mc-hcp-btn">Nein, trotzdem fortfahren</button>'
      + '</div>';
    document.body.appendChild(ov);
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    function close() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      document.body.style.overflow = prevOverflow;
      if (ov.parentNode) ov.parentNode.removeChild(ov);
      if (st.parentNode) st.parentNode.removeChild(st);
    }
    document.getElementById('mc-hcp-yes').addEventListener('click', close);
    document.getElementById('mc-hcp-no').addEventListener('click', close);
  }
  if (document.body) show();
  else document.addEventListener('DOMContentLoaded', show);
})();
/* ===== HCP-OPTIN END ===== */
